import { Component, Input } from '@angular/core';
import { IconModes } from '@app/shared/enums/buttons';
import { TranslateService } from '@ngx-translate/core';
import { BasicButtonComponent } from '../basic-button/basic-button.component';

@Component({
  selector: 'cm-text-button-with-icon',
  templateUrl: './text-button-with-icon.component.html',
  styleUrls: ['../basic-button/basic-button.component.scss', './text-button-with-icon.component.scss'],
})
export class TextButtonWithIconComponent extends BasicButtonComponent {
  @Input() icon: string;
  @Input() iconMode: IconModes = IconModes.FILLED;
  @Input() height = 'auto';
  @Input() public iconPosition: 'left' | 'right' = 'left';
  @Input() isLoading: boolean;
  @Input() hasError;
  @Input() disabled: boolean;
  @Input() dataCy: string;
  @Input() svgIcon: string;
  public spinnerDiameter = 55;

  constructor(protected translateService: TranslateService) {
    super(translateService);
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Firefox') != -1) {
      this.spinnerDiameter = 17;
    }
  }
}
